// SPDX-License-Identifier: Apache-2.0

import { BiX } from "react-icons/bi";
import { useTranslation } from "react-i18next";

/**
 * Close control for the react-bootstrap modals. The library's own
 * `closeButton` emits Bootstrap 5 markup (`.btn-close`), but this app ships
 * the Bootstrap 4 stylesheet, which has no rule for it — the button rendered
 * as an unstyled 16×6 px sliver that looked like a dash. Every other window
 * (swap status, network cards) closes with the same X icon, so use it here.
 */
export default function ModalCloseButton({ onClick }: { onClick: () => void }) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      className="close-button modal-close-x"
      aria-label={t("close")}
      onClick={onClick}
    >
      <BiX size={20} />
    </button>
  );
}
